const routes = [
  {
    path: '/category-tool',
    name: 'category-tool',
    component: () => import('@/modules/tools/pages/CategoryTool.vue'),
    meta: {
      requiresAuth: true,
      title: 'eRank — Category Tool',
      metaTags: [
        {
          name: 'description',
          content: 'This tool helps identify the most popular categories for the keywords entered by identifying the most appropriate category for your listing.',
        },
        {
          page_slug: 'category-tool',
        },
      ],
    },
  },
  {
    path: '/calculators/',
    name: 'calculators',
    component: () => import('@/modules/tools/pages/Calculators.vue'),
    meta: {
      requiresAuth: true,
      title: 'eRank —  Calculators',
      metaTags: [
        {
          name: 'description',
          content: 'Estimate the cost of selling your items and evaluate the performance of your Etsy Ads campaigns.',
        },
        {
          page_slug: 'profit-calculator',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'calculators.entry',
        redirect: { name: 'profit-calculator' },
      },
      {
        path: 'profit-calculator',
        name: 'profit-calculator',
        component: () => import('@/modules/tools/pages/ProfitCalculator.vue'),
        meta: {
          title: 'eRank —  Calculators',
          metaTags: [
            {
              name: 'description',
              content: 'This tool helps estimate your Etsy fees and profit.  By entering the price of the item along with labor, material, and shipping cost, it produces the estimate of the fees you will have to pay and the profit you expect to make.',
            },
            {
              page_slug: 'profit-calculator',
            },
          ],
        },
      },
      {
        path: 'ad-spend-calculator',
        name: 'ad-spend-calculator',
        component: () => import('@/modules/tools/pages/AdSpendCalculator.vue'),
        meta: {
          title: 'eRank —  Calculators',
          metaTags: [
            {
              name: 'description',
              content: 'This tool helps estimate your Etsy fees and profit.  By entering the price of the item along with labor, material, and shipping cost, it produces the estimate of the fees you will have to pay and the profit you expect to make.',
            },
            {
              page_slug: 'ad-spend-calculator',
            },
          ],
        },
      },
    ],
  },
];

export default routes;